import type { AppStrings } from './types.js';

export const id: AppStrings = {
  // COMMON
  error_title: 'Error',
  cancel: 'Batal',
  retry: 'Coba lagi',
  back_arrow: '← Kembali',

  // ASK SCREEN
  ask_box_unavailable: 'Kotak tidak tersedia',
  ask_box_unavailable_desc: 'Tautan mungkin sudah kedaluwarsa atau pemiliknya menutup kotak.',
  ask_create_own_box: 'Buat kotakmu sendiri',
  ask_sent_title: 'Terkirim ✅',
  ask_sent_desc: 'Pertanyaan anonim kamu sudah sampai ke pemilik kotak.',
  ask_anonymous_hint: 'Pertanyaanmu akan dikirim secara anonim.',
  ask_placeholder: 'Tulis pertanyaanmu…',
  ask_send: 'Kirim',
  ask_sending: 'Mengirim…',
  ask_error_rate_limit: 'Terlalu banyak permintaan — tunggu sebentar ya.',
  ask_error_restart: 'Silakan restart Mini App.',
  ask_error_load: 'Gagal memuat kotak.',
  ask_error_send: 'Gagal mengirim pertanyaan.',
  ask_error_banned: 'Kamu diblokir di aplikasi ini.',
  ask_banned_appeal_btn: 'Ajukan banding',
  ask_appeal_sent: 'Banding dikirim. Kami akan meninjaunya secara manual.',

  // AGE GATE
  age_gate_title: 'Khusus 18+',
  age_gate_desc:
    'Kamu akan mengirim pertanyaan anonim. Bersikaplah sopan: pelecehan, ancaman, konten seksual yang melibatkan anak di bawah umur, dan konten yang melanggar hukum dilarang keras. Anonim bukan berarti bebas tanggung jawab — pelanggaran akan dilaporkan ke moderasi. Dengan mengirim pertanyaan, kamu menyatakan berusia 18+ dan menyetujui aturan.',
  age_gate_confirm: 'Saya 18+ — lanjutkan',

  // INBOX SCREEN
  inbox_title: 'Kotak saya',
  box_link_accordion: 'Tautan undangan',
  inbox_notifications_ask: '🔔 Izinkan bot mengirim notifikasi pertanyaan baru?',
  inbox_notifications_allow: 'Izinkan',
  inbox_notifications_dismiss_label: 'Tutup',
  inbox_box_toggle_disable: 'Nonaktifkan pertanyaan',
  inbox_box_toggle_enable: 'Aktifkan pertanyaan',
  inbox_box_disabled_warning: 'Pertanyaan dinonaktifkan — tidak ada pertanyaan baru yang diterima.',
  inbox_share_hint: 'Bagikan tautan agar teman-temanmu bisa bertanya secara anonim.',
  inbox_copy: 'Salin',
  inbox_copied: 'Tersalin',
  inbox_copy_error: 'Error',
  inbox_no_deeplink: 'Tautan akan muncul setelah deploy.',
  inbox_invite_story: 'Undang via Story',
  inbox_invite_chat: 'Undang via chat',
  inbox_card_rendering: 'Kartu undangan masih dibuat.',
  inbox_story_unsupported:
    'Story tidak tersedia di versi Telegram ini. Coba "via chat".',
  inbox_story_error: 'Gagal membuka Story.',
  inbox_chat_unsupported:
    'Berbagi ke chat tidak tersedia di versi Telegram ini. Perbarui aplikasimu.',
  inbox_chat_error: 'Gagal berbagi. Coba lagi ya.',
  inbox_chat_prepare_error: 'Gagal menyiapkan undangan.',
  inbox_filter_incoming: 'Masuk',
  inbox_filter_hidden: 'Disembunyikan',
  inbox_filter_blocked: 'Diblokir',
  inbox_filter_empty: 'Belum ada apa-apa di sini.',
  inbox_acc_unanswered: 'Belum dijawab',
  inbox_acc_answered: 'Sudah dijawab',
  inbox_acc_hidden: 'Disembunyikan',
  inbox_acc_blocked: 'Diblokir',
  inbox_empty: 'Belum ada pertanyaan. Bagikan tautannya dulu yuk.',
  inbox_load_more: 'Muat lebih banyak',
  inbox_load_more_error: 'Gagal memuat halaman berikutnya.',
  inbox_error_load: 'Gagal memuat kotak.',
  inbox_rate_limit: 'Terlalu banyak permintaan — tunggu sebentar ya.',
  inbox_toggle_error: 'Gagal mengubah status kotak.',

  // MESSAGE BOX (Трек D)
  message_tagline: 'Tulis untukku secara anonim',
  message_placeholder: 'Tulis pesan…',
  message_anonymous_hint: 'Pesanmu akan dikirim secara anonim.',
  message_sent_title: 'Terkirim ✅',
  message_sent_desc: 'Pesan anonim kamu sudah terkirim.',
  message_owner_entry: 'Tulis untukku',
  message_share_hint: 'Bagikan tautan agar siapa pun bisa mengirimimu pesan anonim.',
  message_inbox_open: 'Pesan diterima',
  message_inbox_title: 'Pesan',
  message_inbox_empty: 'Belum ada pesan. Bagikan tautanmu dulu yuk.',

  // ANSWER SCREEN
  answer_title: 'Jawab pertanyaan',
  answer_placeholder: 'Tulis jawabanmu…',
  answer_submit: 'Kirim',
  answer_submitting: 'Mengirim…',
  answer_back: 'Kembali',
  answer_error_send: 'Gagal mengirim jawaban.',

  // SHARE SCREEN
  share_title: 'Jawaban dipublikasikan ✅',
  share_hint: 'Bagikan kartunya dan kumpulkan lebih banyak pertanyaan.',
  share_card_rendering_desc:
    'Kartu masih dibuat. Kembali ke pertanyaan dan cek lagi sebentar — kamu bisa membagikannya ke Story atau chat.',
  share_card_alt: 'Kartu jawaban',
  share_story_btn: 'Bagikan ke Story',
  share_story_btn_busy: 'Membuka…',
  share_chat_btn: 'Bagikan ke chat',
  share_chat_btn_busy: 'Menyiapkan…',
  share_back: 'Kembali ke pertanyaan',
  share_story_unsupported:
    'Story tidak tersedia di versi Telegram ini. Coba "Bagikan ke chat".',
  share_story_error: 'Gagal membuka Story. Coba "Bagikan ke chat".',
  share_chat_sent: 'Pesan terkirim.',
  share_chat_unsupported:
    'Berbagi ke chat tidak tersedia di versi Telegram ini. Perbarui aplikasimu.',
  share_chat_error: 'Gagal berbagi. Coba lagi ya.',
  share_chat_prepare_error: 'Gagal menyiapkan pesan.',

  // LEADERBOARD SCREEN
  lb_title: 'Papan peringkat',
  lb_period_7d: '7 hari',
  lb_period_30d: '30 hari',
  lb_period_all: 'Semua waktu',
  lb_group_label: 'Kategori',
  lb_group_all: 'Semua',
  lb_group_ask: 'Tanya',
  lb_group_rate: 'Nilai',
  lb_group_confession: 'Curhat',
  lb_group_guesswho: 'Tebak siapa',
  lb_group_message: 'Pesan',
  lb_error: 'Gagal memuat papan peringkat',
  lb_empty: 'Belum ada yang masuk peringkat',
  lb_anon: 'Anonim',
  lb_load_more: 'Muat lebih banyak',
  lb_questions: (n) => `${n} pertanyaan`,
  lb_referrals: (n) => `${n} referral`,

  // REWARDS SCREEN
  rw_title: 'Hadiah saya',
  rw_error: 'Gagal memuat hadiah',
  rw_level: (n) => `Level ${n}`,
  rw_confirmed_referrals: (n) => `${n} referral terkonfirmasi`,
  rw_next_level_section: (n) => `LEVEL BERIKUTNYA — ${n} referral`,
  rw_to_level: (level, target) => `ke level ${level}: ${target} lagi`,
  rw_max_level: 'Level maksimum tercapai!',
  rw_badges_section: 'LENCANA',
  rw_formats_section: 'TEMA KOTAK',

  // QUESTION CARD
  qcard_status_new: 'Baru',
  qcard_status_hidden: 'Disembunyikan',
  qcard_status_answered: 'Sudah dijawab',
  qcard_moderation_flagged: 'Perhatian: pesan mencurigakan',
  qcard_answer_btn: 'Jawab',
  qcard_answer_send: 'Kirim',
  qcard_share_btn: 'Bagikan',
  qcard_hide_btn: 'Sembunyikan',
  qcard_show_btn: 'Tampilkan',
  qcard_report_btn: 'Laporkan',
  qcard_block_btn: 'Blokir',
  qcard_unblock_btn: 'Buka blokir',
  qcard_report_reason_label: 'Pilih alasan laporan:',
  qcard_reason_spam: 'Spam',
  qcard_reason_harassment: 'Pelecehan',
  qcard_reason_sexual: 'Konten seksual',
  qcard_reason_other: 'Lainnya',
  qcard_error_hide: 'Gagal mengubah visibilitas.',
  qcard_error_report: 'Gagal mengirim laporan.',
  qcard_error_block: 'Gagal memblokir pengirim.',
  qcard_report_done: 'Laporan terkirim — terima kasih.',
  qcard_block_done: 'Pengirim diblokir.',
  qcard_unblock_done: 'Blokir dibuka.',

  // ERRORS
  err_network: 'Tidak bisa terhubung ke server. Cek koneksi internetmu dan coba lagi.',
  err_server_unavailable: 'Server sedang tidak tersedia, coba lagi nanti ya.',
  err_internal: 'Ada yang tidak beres di pihak kami. Kami sedang memperbaikinya — coba lagi nanti.',
  err_bad_request: 'Periksa data yang kamu masukkan.',
  err_generic: 'Tindakan tidak berhasil, coba lagi nanti ya.',
  err_schema: 'Error data. Coba perbarui aplikasinya.',
  share_story_link_premium_note:
    'Tautan yang bisa diklik di Story memerlukan Telegram Premium. Tanpa itu pun teman-temanmu tetap bisa menemukanmu — username-mu terlihat di kartu.',

  // AUTH ERROR SCREEN
  auth_error_title: 'Error akses',
  auth_error_desc:
    'Gagal melakukan autentikasi. Tutup dan buka kembali Mini App dari Telegram.',

  // REWARD TOAST
  reward_toast_title: 'Hadiah baru!',
  reward_toast_close: '×',

  // BOTTOM TABBAR
  tab_questions: 'Pertanyaan',
  tab_leaderboard: 'Peringkat',
  tab_rewards: 'Hadiah',
  tab_settings: 'Pengaturan',

  // SETTINGS SCREEN
  settings_title: 'Pengaturan',
  settings_section_general: 'Umum',
  settings_notifications: 'Notifikasi pertanyaan baru',
  settings_notifications_hint: 'Bot akan memberi tahu kamu saat ada yang bertanya.',
  settings_notifications_error: 'Gagal menyimpan pengaturan notifikasi.',
  settings_language: 'Bahasa',
  settings_language_error: 'Gagal mengganti bahasa. Coba lagi ya.',
  settings_section_about: 'Tentang',
  settings_version: 'Versi',

  // CODE ENTRY (work-020)
  code_modal_title: 'Tautan Story khusus Premium',
  code_modal_explain:
    'Telegram hanya memberikan tautan Story yang bisa diklik kepada pelanggan Premium. Sebagai gantinya, tambahkan kode kamu ke Story — penonton mengetiknya di aplikasi dan bisa bertanya secara anonim.',
  code_modal_your_code: 'Kode kamu',
  code_modal_copy: 'Salin kode',
  code_modal_copied: 'Tersalin',
  code_modal_share_btn: 'Bagikan ke Story',
  code_modal_loading: 'Mendapatkan kode…',
  code_modal_error: 'Gagal mendapatkan kode. Coba lagi nanti ya.',
  ask_code_title: 'Masukkan kode',
  ask_code_desc:
    'Dari Story? Temukan kode di Story-nya (misalnya 1234) dan ketik di bawah.',
  ask_code_placeholder: 'Kode dari Story',
  ask_code_find: 'Cari',
  ask_code_not_found: 'Kode tidak ditemukan. Periksa angkanya dan coba lagi.',
  ask_code_invalid: 'Kode terdiri dari 4 digit.',
  code_onboarding_header: 'Dari Story?',
  code_onboarding_text: 'Masukkan kode temanmu untuk bertanya secara anonim.',
  code_onboarding_action: 'Masukkan kode',
  settings_ask_by_code: 'Tanya lewat kode',
  settings_my_code_title: 'Kode Story kamu',
  settings_my_code_hint:
    'Tulis kode ini di Story-mu — penonton memasukkannya untuk bertanya secara anonim. Tautan Story yang bisa diklik hanya untuk pelanggan Telegram Premium.',
  settings_my_code_rotate: 'Dapatkan kode baru',
  settings_my_code_rotating: 'Memperbarui…',
  settings_my_code_done: 'Kode diperbarui',
  settings_my_code_error: 'Gagal mendapatkan kode.',
  settings_my_code_rotate_confirm_title: 'Ganti kode kamu?',
  settings_my_code_rotate_confirm_desc:
    'Kode lama kamu langsung berhenti berfungsi. Semua orang yang melihatnya di Story kamu nggak bisa lagi menghubungi kamu. Ganti cuma kalau ada yang spam kamu.',
  settings_my_code_rotate_confirm_action: 'Ganti kode',

  // BOT
  bot_greeting: (name) => (name ? `Halo, ${name}! 👋` : 'Halo! 👋'),
  bot_onboarding:
    'Ini adalah VeylMe — pertanyaan anonim.\n\n' +
    'Buka Mini App, posting kartu «Tanyakan aku secara anonim» ke Story-mu — ' +
    'dan terima pertanyaan anonim langsung di sini.\n\n' +
    '⚠️ 18+. Bersikaplah hormat: perundungan, ancaman, dan konten terlarang ' +
    'tidak diizinkan. Anonimitas ≠ kebebasan dari hukuman — pelanggaran dilaporkan ke moderasi.',
  bot_open_btn: 'Buka VeylMe',
  notify_answer_btn: 'Jawab',
  bot_invite_text:
    'Seseorang membagikan tautan VeylMe.\n\n' +
    'Buka Mini App untuk mengajukan pertanyaan anonim:',
  bot_invite_btn: 'Tanya secara anonim',

  // WORK-027 i18n sweep
  tagline: 'Tanyakan aku secara anonim',
  share_ask_action: 'Tanya',
  share_answered_text: 'Aku menjawab pertanyaan anonim 👀',
  err_not_in_telegram: 'Mini App tidak berjalan di Telegram. Silakan restart aplikasi.',
  badge_viral_starter: 'Awal viral',
  badge_storyteller: 'Pendongeng',
  badge_loop_master: 'Master loop',
  theme_confession: 'Curhat',
  theme_guesswho: 'Tebak siapa',
  rw_format_named: (name) => `format «${name}»`,
  card_label_question: 'Pertanyaan',
  card_label_answer: 'Jawaban',
  card_invite_subtitle: 'anonim, tanpa daftar',
  card_code_hint: 'MASUKKAN KODE DI APLIKASI',
  share_msg_title: (brand) => `${brand} · Pertanyaan anonim`,
  notify_new_question: '🔔 Seseorang mengajukan pertanyaan anonim kepadamu',
  notify_unanswered_reminder: (n) => `🔔 Kamu punya ${n} pertanyaan yang belum dijawab`,
  notify_ban_permanent: 'permanen',
  notify_ban_until: (date) => `sampai ${date}`,
  notify_ban_msg: (untilPhrase) =>
    `⛔ Kamu diblokir di VeylMe ${untilPhrase}. Terlalu banyak penerima yang melaporkan pesanmu.\nJika menurutmu ini kesalahan, kamu bisa mengajukan banding di aplikasi.`,
  notify_warning_msg:
    '⚠️ Beberapa penerima melaporkan pesanmu. Sedikit lagi dan kamu akan diblokir di VeylMe.',

  // MY QUESTIONS SCREEN + InvitePanel non-premium hint (retention-answer-loop)
  my_questions_title: 'Pertanyaanku',
  my_questions_empty_title: 'Kamu belum mengajukan pertanyaan',
  my_questions_empty_desc: 'Ajukan pertanyaan ke kotak seseorang — balasannya akan muncul di sini.',
  my_questions_loading: 'Memeriksa balasan…',
  my_questions_waiting: 'Menunggu balasan',
  my_questions_answer_label: 'Balasan',
  settings_my_questions: 'Pertanyaanku',
  ask_sent_find_reply_hint: 'Kamu bisa menemukan balasannya nanti di «Pertanyaanku».',
  inbox_story_nonpremium_hint: 'Tautan Story tidak bisa diklik tanpa Telegram Premium, jadi kami tampilkan kode — berbagi ke chat lebih andal.',

  // SESSION EXPIRY SCREEN (work-038)
  session_expired_title: 'Izin Telegram sudah kedaluwarsa',
  session_expired_desc: 'Telegram memberi aplikasi izin hanya sekali saat dibuka, dan izin ini sudah kedaluwarsa. Buka aplikasi lagi — teks yang kamu mulai sudah kami simpan.',
  session_expired_desc_no_storage: 'Izin Telegram kamu sudah kedaluwarsa dan aplikasi perlu dibuka lagi. Kami tidak bisa menyimpan teks yang kamu ketik — salin dulu sebelum kamu keluar.',
  session_expired_reopen: 'Buka lagi',
  session_expired_stuck_title: 'Telegram mengembalikan izin lama yang sama',
  session_expired_stuck_desc: 'Tutup aplikasi sepenuhnya lewat menu bot lalu buka lagi — barulah Telegram memberi izin baru.',
  session_auth_failed_title: 'Tidak bisa memastikan loginmu',
  session_auth_failed_desc: 'Telegram tidak memastikan loginmu ke aplikasi. Tutup aplikasi dan buka lagi dari chat dengan bot.',
  session_expired_manual_close: 'Aplikasi tidak bisa menutup dirinya sendiri di sini — tutup sendiri lalu buka lagi dari chat dengan bot.',
  session_expiring_soon: 'Izin Telegram akan segera kedaluwarsa. Buka aplikasi lagi supaya tidak ada yang hilang.',
  my_questions_check_failed: 'Tidak bisa memeriksa balasan. Coba lagi nanti.',
  settings_notifications_load_error: 'Tidak bisa memuat pengaturan ini.',
};
